/**
 * Require an authenticated user before rendering children.
 *
 * Used to wrap customer routes that call protected APIs (e.g.
 * /addresses, /wallet, /orders, /account). Without this guard, an
 * anonymous visit to these URLs would fire a 401 from the backend,
 * which surfaces as a noisy React dev-overlay during local dev and a
 * silent empty state in production. With this guard, we redirect to
 * /login (preserving the intended destination so we can bounce the
 * user back after they sign in).
 */
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { FullPageLoader } from "./Loaders";

export default function RequireAuth({ children }) {
    const { user, loading } = useAuth();
    const loc = useLocation();
    if (loading) return <FullPageLoader />;
    if (!user) {
        return (
            <Navigate
                to="/login"
                replace
                state={{ next: loc.pathname + (loc.search || "") }}
            />
        );
    }
    return children;
}
